export enum EDevicePriority {
  LOW_PRIORITY = "LOW_PRIORITY",
  HIGH_PRIORITY = "HIGH_PRIORITY",
}
